import React, { useEffect, useState } from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import NotificationManager from "react-notifications/lib/NotificationManager";
import { staffPlanTemplateService } from "../../services/staffPlanTemplateService";
import Loader from "../../control-components/loader/loader";
import InputKendoRct from "../../control-components/input/input";

const UpdateStaffTemplate = ({ onClose, documentTemplateId, regionId, editSelectedData, getAllDefaultStaffDocumentTemplates }) => {
    const [loading, setLoading] = useState(false);
    const [templateType, setTemplateType] = useState([])
    const [fields, setField] = useState({
        templateName: editSelectedData?.templateName,
        htmlFileName: editSelectedData?.htmlFileName
    })

    const editTemplate = async () => {
        setLoading(true);
        await staffPlanTemplateService
            .updateStaffTemplate(fields, documentTemplateId, regionId)
            .then((result) => {
                setLoading(false);
                NotificationManager.success("Update Staff Plan Template successfully");
                getAllDefaultStaffDocumentTemplates()
                onClose({ updated: true });

            })
            .catch((error) => {
                setLoading(false);
                NotificationManager.error(error);
            });
    };

    const handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value
        setField({
            ...fields,
            [name]: value
        })
    }
    const handleSubmit = () => {
        editTemplate();
    };

    return (
        <div>
            {loading == true && <Loader />}
            <Dialog
                onClose={onClose}
                title={"Edit Staff Plan Template"}
                className="small-dailog"
            >
                <div className="edit-client-popup">
                    <div className="popup-modal slibling-data">
                        <div className="row">
                             <div className="mt-2">
                                <InputKendoRct
                                    value={fields.templateName}
                                    onChange={handleChange}
                                    name="templateName"
                                    label="Template Name"
                                    className="form-control"
                                    placeholder="Template name"
                                />
                            </div>
                            <div className="mt-2">
                                <InputKendoRct
                                    value={fields.htmlFileName}
                                    onChange={handleChange}
                                    name="htmlFileName"
                                    label="Html File Name"
                                    className="form-control"
                                    placeholder="Template name"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="border-bottom-line"></div>
                <div className="d-flex my-3">
                    <div className="right-sde">
                        <button className="green-btn btn-primary mx-3" onClick={handleSubmit}>
                            Update
                        </button>
                    </div>
                    <div className="right-sde-grey">
                        <button
                            className="btn grey-secondary text-white "
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </Dialog>
        </div>
    );
};
export default UpdateStaffTemplate;
